import type { ThemeConfig } from 'antd';
import { LooseObjectType } from 'utils/globalTypes';
import { BRAND_CODES } from 'utils/brand-config';
import { defaultConfig, defaultVariables } from 'theme/default';
import { mgsafeConfig, mgsafeVariables } from 'theme/mgsafe';
import { dshopConfig, dshopVariables } from 'theme/dshop';
import { dsafeConfig, dsafeVariables } from 'theme/dsafe';
import { partyhatConfig, partyhatVariables } from 'theme/partyhat';
import { protectivConfig, protectivVariables } from 'theme/protectiv';
import { phSafeConfig, phSafeVariables } from 'theme/phsafe';

type brandConfig = {
  config: ThemeConfig;
  variables: LooseObjectType;
};

const BRAND_THEME_CONFIG: LooseObjectType<brandConfig> = {
  [BRAND_CODES.missGroupSafe]: {
    config: mgsafeConfig,
    variables: mgsafeVariables,
  },
  [BRAND_CODES.domeneShop]: {
    config: dshopConfig,
    variables: dshopVariables,
  },
  [BRAND_CODES.domainkeskusSafe]: {
    config: dsafeConfig,
    variables: dsafeVariables,
  },
  [BRAND_CODES.partyhat]: {
    config: partyhatConfig,
    variables: partyhatVariables,
  },
  [BRAND_CODES.protectIV]: {
    config: protectivConfig,
    variables: protectivVariables,
  },
  [BRAND_CODES.phSafe]: {
    config: phSafeConfig,
    variables: phSafeVariables,
  },
  default: {
    config: defaultConfig,
    variables: defaultVariables,
  },
};

export default BRAND_THEME_CONFIG;
